export function MyNav(){
    return (
        <nav>
            {/* Hello, Welcome to my page. */}
            <ul>

            </ul>
        </nav>
    )
}